import { AccountTypes } from '../../components/changeUser/accountTypes.enum';
import { Account } from '../../state/reduxRepositories/accounts/accounts.interfaces';
import { Conneqt } from '../../state/reduxRepositories/conneqt/conneqt.interfaces';
import { dateTime } from '../../time/datetime';

export const validateEmail = (email: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// TODO: move all calls of getPlayerDetails into domain services and return result instead.
export const getPlayerDetails = (clues: string | undefined) => {
  if (!clues) {
    return undefined;
  }
  const playerDetails: string[] = clues.split(',');
  const name: string = playerDetails[0];
  const dateOfBirth: string = playerDetails[1];

  // There are two possible formats for dob - 'YYYY-MM-DD' and the old one 'DD/MM/YYYY'
  // Check if dob has the 'YYYY-MM-DD' format
  if (dateOfBirth && !dateTime.isFormattedAs(dateOfBirth, 'YYYY-MM-DD')) {
    const convertedDateOfBirth: string | null = dateTime.convertToDate(
      dateOfBirth,
      true,
    );
    if (convertedDateOfBirth) {
      return { name, dob: convertedDateOfBirth };
    }
  }

  return { name, dob: dateOfBirth };
};

export const createConneqtRequestsViewPayload = (
  conneqt: Conneqt,
  accounts: Account[],
) => {
  return {
    id: conneqt.id,
    accountId: conneqt.accountId,
    responseEmail: conneqt.responseEmail, // getRequestedUser(conneqt, accounts),
    responseAccountName: getRequestedUser(conneqt, accounts),
    requestPlayerClues: conneqt.requestPlayerClues,
    requestPlayerPhone: getRequestedUserPhoneNumber(conneqt, accounts),
    status: conneqt.status,
    requestPlayerId: conneqt.requestPlayerId,
    responsePlayerId: conneqt.responsePlayerId,
    requestUserEmail: conneqt.requestUserEmail,
    accountName: conneqt.accountName,
    disconnectedAccountId: conneqt.disconnectedAccountId,
  };
};
// TODO : As all org and clinic accounts should be synced only for guardians even though now we are syncing it with all account types
// should we input this information?
const getRequestedUser = (conneqt: Conneqt, accounts: Account[]) => {
  // For some account type combos (e.g. a guardian sending to a clinic),
  // they might have access to the account record, including the name:
  const responseAccount = getResponseAccount(accounts, conneqt);

  if (responseAccount && responseAccount.name) return responseAccount.name;

  return undefined;
};

const getRequestedUserPhoneNumber = (conneqt: Conneqt, accounts: Account[]) => {
  let phone: string | undefined = '';
  if (conneqt.responseAccountType === AccountTypes.Org) {
    phone = getResponseAccount(
      getAccountsByType(accounts, AccountTypes.Org),
      conneqt,
    )?.phone;
  }

  if (conneqt.responseAccountType === AccountTypes.Clinic) {
    phone = getResponseAccount(
      getAccountsByType(accounts, AccountTypes.Clinic),
      conneqt,
    )?.phone;
  }

  return phone;
};

const getAccountsByType = (accounts: Account[], type: AccountTypes) => {
  return accounts.filter((_account) => _account.type === type);
};

const getResponseAccount = (accounts: Account[], conneqt: Conneqt) => {
  return accounts.find((_account) => {
    return conneqt.responseAccountId === _account.id;
  });
};
